var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import "./devModeButton.css";
/**
 * A button that appears only in development mode for auto-filling forms with random data
 */
var DevModeButton = function (_a) {
    var onClick = _a.onClick;
    // The process.env.DEV_MODE check may not work reliably in React
    // Using window object to check for development mode to ensure button is visible
    var isDevMode = function () {
        // Check if DEV_MODE is explicitly set to true in environment
        if (process.env.DEV_MODE === "true") {
            return true;
        }
        // Fallback methods to detect development mode
        // Check for development domain/hostname
        var hostname = window.location.hostname;
        if (hostname === "localhost" ||
            hostname === "127.0.0.1" ||
            hostname === "dev.myemploy.co.uk" ||
            hostname === "dev.myemploy.co.uk") {
            return true;
        }
        return false;
    };
    // Only render the button if we're in dev mode
    if (!isDevMode()) {
        return null;
    }
    return (_jsx("button", __assign({ className: "dev-mode-button", onClick: onClick, title: "Fill form with random data" }, { children: "\uD83C\uDFB2 Fill Random" })));
};
export default DevModeButton;
